module.exports = "<textarea ng-model=\"fakeVM.value\"\r\n          ng-blur=\"applyNewValue()\"></textarea>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/table/templates/Textarea.html
// module id = 449
// module chunks = 0